<template>
  <component :is="component" v-if="component" :detailLayout="detailLayout" :utilityData="utilityData"
             :utilKey="utilKey" :userKey="userKey" :utilTopCategory="utilityTopCategoryList" :utilBottomCategory="utilityBottomCategoryList"></component>

</template>

<script>

export default {
  name: "UtilityDetailLink",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    detailLayout: '',
    utilityData: {},
    utilKey: '',
    userKey: '',
    utilityTopCategoryList: [],
    utilityBottomCategoryList: [],
  },
  data() {
    return {
      component: null
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
    this.detailLoader()
  },
  beforeUnmount() {},
  unmounted(){},
  computed: {
    loader() {
      if (!this.detailLayout) {
        return null
      }
      return () => import(`@/template/utility/detail/${this.detailLayout}`)
    },
  },
  methods: {
    detailLoader() {
      this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/template/utility/detail/UtilityDetailDefaultLayout')
        })
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
